import {useMutation} from '@tanstack/react-query';

import {postExamRebooking} from '../../services/postExamRebooking';

export const usePostExamRebookingMutation = () => {
	return useMutation({
		mutationFn: postExamRebooking,
	});
};
